import { Container } from 'ui';
import { FunctionComponent } from 'react';
import { GiftCardBalanceRoute } from 'routes/protected/account/GiftCardBalanceRoute';
import { Page } from 'layout/Page';
import { PaymentMethodsRoute } from 'routes/protected/account/PaymentMethodsRoute';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { StoreType, useActions } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { useSelector } from 'react-redux';
import AccountMenuRoute from 'routes/protected/account/AccountMenuRoute';
import AccountNav from 'components/account/AccountNav';
import AccountPlaylistsRoute from './AccountPlaylistsRoute';
import AccountProfileRoute from 'routes/protected/account/account-settings/AccountSettingsRoute';
import EmailConfirmationBanner from 'components/account/EmailConfirmationBanner';
import SectionHeader from 'components/SectionHeader';
import TransactionsRoute from 'routes/protected/account/TransactionsRoute';
import clsx from 'clsx';

const AccountRoute: FunctionComponent<RouteComponentProps> = ({ location }) => {
  const { actions } = useActions();
  const patronProfile = useSelector((state: StoreType) => state.app.patronProfile);
  const handleResendConfirmation = () => {
    actions.app.patronActivateResend();
  };

  if (!patronProfile) {
    return null;
  }

  return (
    <Page>
      <Container>
        <EmailConfirmationBanner
          patron={patronProfile.patron as core.Patron}
          onResendConfirmation={handleResendConfirmation}
          getPatronStatus={actions.app.fetchPatronProfile}
        />

        <SectionHeader modifierClassName="Account-header" heading="Profile" />

        <div className={clsx('Account', { 'is-root': location.pathname === '/profile/account' })}>
          <AccountNav
            patron={patronProfile.patron as core.Patron | undefined}
            patronProfile={patronProfile}
          />
          <Switch>
            <Route path={`/profile/account/profile`} component={AccountProfileRoute} />
            <Route path={`/profile/account/transactions`} component={TransactionsRoute} />
            <Route path={`/profile/account/gift-cards`} component={GiftCardBalanceRoute} />
            <Route path={`/profile/account/billing`} component={PaymentMethodsRoute} />
            <Route path={`/profile/account/playlists`} component={AccountPlaylistsRoute} />
            {/* The following route can be deprecated when the new guest navigation is rolled out to
              all guests, as the account menu page is being deprecated - Brian P. 7/29/21 */}
            <Route path={`/profile/account`} component={AccountMenuRoute} />
            <Redirect to={`/profile/account`} />v
          </Switch>
        </div>
      </Container>
    </Page>
  );
};

export default AccountRoute;
